module.exports = __webpack_public_path__ + "img/horizontal_4_1_r_5012.967b8581.png";